<script setup lang="ts">
import type { MLoadRef } from '~/components/m/MLoad.vue'

definePageMeta({
  layout: 'account-center'
})
const id = Number(useRoute().params.id?.toString())
const isSelf = useState<boolean>('is_account_self')
const emptyText = isSelf.value
  ? '这是你的全部关注啦喵~'
  : '只能看一点点，不能看多喽~'

const empty = ref(false)
const loaded = ref(false)
const list = ref<User.FollowListItem[]>([])
const loadRef = ref<MLoadRef>()

onMounted(async () => {
  await load()
})

async function load() {
  const res = await fetchUserFollowList(id, 'follow')
  empty.value = res.length === 0
  list.value = res
  loaded.value = true
  loadRef.value?.check()
}

async function loadMore(ev?: { complete: () => void }) {
  if (empty.value || !loaded.value) {
    ev?.complete()
    return
  }
  const lastId = list.value[list.value.length - 1]?.id || 0
  const more = await fetchUserFollowList(id, 'follow', lastId)
  empty.value = more.length === 0
  list.value.push(...more)
  ev?.complete()
}
</script>

<template>
  <MContainer
    :title="isSelf ? '我的关注' : 'TA的关注'"
    padding
    class="m-member"
  >
    <div v-for="u in list" :key="u.id" class="m-list-item">
      <m-user-info
        :id="u.user.id"
        :avatar="u.user.avatar"
        :badges="u.user.badges"
        :name="u.user.name"
        :auth="u.user.user_auth"
        :name-color="u.user.name_color"
        link
        size="lg"
      >
        <div>
          <div>粉丝数：{{ u.user.fans }}</div>
          <div>{{ u.user.info }}</div>
        </div>
      </m-user-info>
    </div>
    <m-load
      ref="loadRef"
      :empty="empty"
      :empty-text="emptyText"
      @on-scroll-end="loadMore"
    />
  </MContainer>
</template>

<style lang="scss" scoped>
.m-list-item {
  padding: 18px 0;
  border-bottom: 1px solid var(--color-gray-200);
}
</style>
